import { PRO_PLAYERS } from '@/components/trial/shared/pro-players';

/* ─── colors ──────────────────────────────────────────────── */

export const BG_DARK = '#080809';
export const NOPING_GREEN = '#93FF18';
export const DANGER_RED = '#FF3B3B';
export const SHIELD_CYAN = '#06B6D4';
export const SHIELD_BLUE = '#2ECDFF';
export const TEXT_LIGHT = '#E5E7EB';
export const MUTED_GRAY = '#929298';
export const CARD_BG = '#1A1A1F';
export const CARD_BORDER = '#2B2E35';

/* ─── animation easing ────────────────────────────────────── */

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;
export const EASE_IN_OUT = [0.42, 0, 0.58, 1] as const;

/* ─── ISP pipe data for diagram ───────────────────────────── */

export const ISP_PIPES = [
  { name: 'ISP 1 (Primary)', latency: '12ms', status: 'Active', color: NOPING_GREEN },
  { name: 'ISP 2 (Fiber)', latency: '8ms', status: 'Active', color: SHIELD_CYAN },
  { name: 'ISP 3 (Cable)', latency: '15ms', status: 'Active', color: SHIELD_BLUE },
  { name: 'ISP 4 (5G)', latency: '18ms', status: 'Standby', color: '#A8A8DC' },
  { name: 'ISP 5 (DSL)', latency: '22ms', status: 'Standby', color: '#E47435' },
  { name: 'ISP 6 (Backup)', latency: '25ms', status: 'Standby', color: '#CC4194' },
] as const;

/* ─── Game images ─────────────────────────────────────────── */

export const GAME_IMAGES = [
  { name: 'CS2', src: '/images/CS2.webp' },
  { name: 'Valorant', src: '/images/Valorant.webp' },
  { name: 'Fortnite', src: '/images/Fortnite.webp' },
  { name: 'Dota 2', src: '/images/Dota2.webp' },
  { name: 'World of Warcraft', src: '/images/World of Warcraft.webp' },
  { name: 'Final Fantasy XIV', src: '/images/Final Fantasy XIV.webp' },
  { name: 'Ragnarok', src: '/images/Ragnarok.webp' },
  { name: 'StarCraft', src: '/images/StarCraft.webp' },
  { name: 'Tibia', src: '/images/Tibia.png' },
  { name: 'Warface', src: '/images/Warface.png' },
  { name: 'Albion Online', src: '/images/Albion.png' },
  { name: 'Lineage II', src: '/images/Lineage II.webp' },
  { name: 'Rainbow Six Siege', src: '/images/Rainbow Six Siege.png' },
] as const;

/* ─── NoPing Tools (Multi-Internet first) ─────────────────── */

export const V5A_TOOLS = [
  { name: 'Multi-Internet', icon: 'shield', star: true, accent: SHIELD_CYAN },
  { name: 'FPS Boost', icon: 'zap', star: false, accent: NOPING_GREEN },
  { name: 'Aim Trainer', icon: 'crosshair', star: false, accent: NOPING_GREEN },
  { name: 'AudioPad', icon: 'headphones', star: false, accent: NOPING_GREEN },
  { name: 'Replay X', icon: 'play', star: false, accent: NOPING_GREEN },
  { name: 'Pro Settings', icon: 'settings', star: false, accent: NOPING_GREEN },
] as const;

/* ─── Multi-Internet tech stats ───────────────────────────── */

export const TECH_STATS = [{ stat: '10' }, { stat: '<50ms' }, { stat: '6' }, { stat: 'BR 102015016756-3' }] as const;

/* ─── Shield vs Sword features (length used for i18n loops) ── */

export const SHIELD_FEATURES = [0, 1, 2, 3, 4] as const;
export const SWORD_FEATURES = [0, 1, 2, 3, 4] as const;

/* ─── Problem stats (values rendered, labels via i18n) ─────── */

export const PROBLEM_STATS = [{ value: '73%' }, { value: '4.2h' }] as const;

/* ─── Hero benefit badges (rendered via i18n keys) ─────────── */

export const HERO_BENEFITS = [0, 1, 2, 3, 4] as const;

/* ─── Pro endorsements ─────────────────────────────────── */

export const PRO_ENDORSEMENTS = [PRO_PLAYERS.sacy, PRO_PLAYERS.gaules, PRO_PLAYERS.coldzera] as const;

/* ─── NoPing stats (inlined from @/lib/constants) ────────── */

export const NOPING_STATS = {
  servers: '2,000+',
  countries: '150+',
  gamesSupported: '3,000+',
  users: '3M+',
} as const;
